import React from "react";

export default class InscriptionInput extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      isValid: true
    }
  }

  validate = (e) => {
    let isValid = true;
    if (this.props.validation === "text") {
      isValid = new RegExp(/^[a-zA-Z áéíóúñÁÉÍÓÚÑ_-]*$/).test(e.target.value)
    } else if (this.props.validation === "number") {
      isValid = new RegExp(/^[0-9]*$/).test(e.target.value)
    }  else if (this.props.validation === "alphanumeric"){
      isValid = new RegExp(/^[0-9a-zA-Z]*$/).test(e.target.value)
    }
    this.setState({
      isValid: isValid
    })
    if (this.props.collectValidations) {
      this.props.collectValidations(this.props.name, isValid);
    }
  }

  getMessage = () => {
    if (this.props.validation === "text") {
      return `Sólo se admiten caracteres alfabeticos`
    } else if (this.props.validation === "number") {
      return `Sólo se permite catecteres numéricos`
    } else if (this.props.validation === "alphanumeric") {
      return `Sólo se permite catecteres alfanuméricos`
    }
  }

  handleChange = (event) => {
    this.validate(event);
    this.props.handleChange(event);
  }

  render() {
    return (
      <>
        <label>{this.props.label}</label>
        <div className="form-label-group">
          <input type="text"
            id={this.props.name}
            name={this.props.name}
            className="form-control"
            placeholder={this.props.label}
            required
            onChange={this.handleChange}
            onBlur={this.props.handleBlur}
            value={this.props.value}
            readOnly={this.props.readOnly}/>
        </div>
        {!this.state.isValid ? <span style={{color: "red"}}>{this.getMessage()}</span> : ""}
        <br/>
      </>
    )
  }
}

